module.exports = __webpack_public_path__ + "img/sp_foot_ico03_active.c451922d.svg";